<h2 mat-dialog-title>Avalie este livro</h2>
<mat-dialog-content>
    <p>O que você achou deste livro? Sua opinião é muito importante para nós!</p>
    <div class="rating-stars">
        <mat-icon *ngFor="let star of stars" (click)="rate(star)" (mouseenter)="hovered = star"
            (mouseleave)="hovered = 0" [class.filled]="star <= (hovered || rating)">
            star
        </mat-icon>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancelar</button>
</mat-dialog-actions>